import script from "./MonitoringLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringLayout.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringLayout.vue?vue&type=style&index=0&id=7afce314&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7afce314"]])

export default __exports__